import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";

import {
    DashboardBlackIcon,
    DashboardWhiteIcon,
    CategoryBlackIcon,
    CategoryWhiteIcon,
    ListBlackIcon,
    ListWhiteIcon,
    MenuBlackIcon,
    MenuWhiteIcon,
    NotificationBlackIcon,
    NotificationWhiteIcon,
    PalleteBlackIcon,
    PalleteWhiteIcon,
    SettingsBlackIcon,
    SettingsWhiteIcon,
    QrCodeBlackIcon,
    QrCodeWhiteIcon,
    OnlineOrderBlackIcon,
    OnlineOrderWhiteIcon,
    TableFrontWhiteIcon,
    TableFrontBlackIcon,
    ChangeUsersIcon,
    LogoutBlackIcon,
    HistoryBlackIcon,
    HistoryWhiteIcon,
} from "../../assets/icons";
import { useAuth } from "../../auth/AuthContext";
import { LocalPlanSubscriptionInfoDTO } from "../../models/PlanSubscription/planSubscription.response";
import { planSubscriptionService } from "../../services/planSubscriptionService";
import Loader from "../shared/Loader";

const SettingsNavbar: React.FC = () => {

    const [localPlanSubscriptionInfo, setLocalPlanSubscriptionInfo] = useState<LocalPlanSubscriptionInfoDTO | null>(null);

    const [loading, setLoading] = useState(false);
    const { localId } = useParams<{ localId: string }>();
    const { logout } = useAuth();

    useEffect(() => {
        fetchLocalPlanSubscriptionInfo();
    }, [localId]);

    const fetchLocalPlanSubscriptionInfo = async () => {
        if (!localId) return;

        setLoading(true);
        try {
            const response = await planSubscriptionService.getLocalPlanSubscriptionInfo(localId);
            if (response.success && response.data) {
                console.log("Fetched local plan subscription info:", response.data.planFeaturesKeys);
                setLocalPlanSubscriptionInfo(response.data);
            }
        } catch (error) {
            console.error("Error fetching local plan subscription info:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <section className="navbar">
                <div className="w-layout-blockcontainer container navbar-container w-container">
                    <div className="navbar-wrapper">
                        <div className="navbar-header-div">
                            {/* TO DO */}
                            {/* <div className="navbar-header-local-name">Restoran Zlatna Lađa</div> */}
                            <div className="navbar-header-info">Admin Panel</div>
                        </div>
                        <div className="navbar-list">

                            <NavLink to={`/settings/${localId}/dashboard`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? DashboardWhiteIcon : DashboardBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">Dashboard</div>
                                    </>
                                )}
                            </NavLink>

                            <NavLink to={`/settings/${localId}/category`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? CategoryWhiteIcon : CategoryBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">Kategorije</div>
                                    </>
                                )}
                            </NavLink>

                            <NavLink to={`/settings/${localId}/subcategory`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? ListWhiteIcon : ListBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">Podkategorije</div>
                                    </>
                                )}
                            </NavLink>

                            <NavLink to={`/settings/${localId}/menu-items`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? MenuWhiteIcon : MenuBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">Stavke menija</div>
                                    </>
                                )}
                            </NavLink>

                            <NavLink to={`/settings/${localId}/notification`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? NotificationWhiteIcon : NotificationBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">Notifikacije</div>
                                    </>
                                )}
                            </NavLink>

                            <NavLink to={`/settings/${localId}/local-events`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? NotificationWhiteIcon : NotificationBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">Događaji u lokalu</div>
                                    </>
                                )}
                            </NavLink>

                            <NavLink to={`/settings/${localId}/theme`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? PalleteWhiteIcon : PalleteBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">Vizuelni identitet</div>
                                    </>
                                )}
                            </NavLink>

                            <NavLink to={`/settings/${localId}/info`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? SettingsWhiteIcon : SettingsBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">Podesavanje lokala</div>
                                    </>
                                )}
                            </NavLink>

                            <NavLink to={`/settings/${localId}/qr-code`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                {({ isActive }) => (
                                    <>
                                        <div className="navbar-entity-photo-div">
                                            <img loading="lazy" src={isActive ? QrCodeWhiteIcon : QrCodeBlackIcon} alt="" className="navbar-entity-photo" />
                                        </div>
                                        <div className="navbar-entity-name">QR Kod</div>
                                    </>
                                )}
                            </NavLink>

                            {localPlanSubscriptionInfo?.planFeaturesKeys.some(f => f.includes("plus-reservation") || f.includes("plus-order-dine-in")) && (
                                <NavLink to={`/settings/${localId}/tables`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                    {({ isActive }) => (
                                        <>
                                            <div className="navbar-entity-photo-div">
                                                <img loading="lazy" src={isActive ? TableFrontWhiteIcon : TableFrontBlackIcon} alt="" className="navbar-entity-photo" />
                                            </div>
                                            <div className="navbar-entity-name">Stolovi</div>
                                        </>
                                    )}
                                </NavLink>
                            )}

                            {localPlanSubscriptionInfo?.planFeaturesKeys.some(f => f.includes("plus-reservation")) && (
                                <NavLink to={`/settings/${localId}/reservation`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                    {({ isActive }) => (
                                        <>
                                            <div className="navbar-entity-photo-div">
                                                <img loading="lazy" src={isActive ? QrCodeWhiteIcon : QrCodeBlackIcon} alt="" className="navbar-entity-photo" />
                                            </div>
                                            <div className="navbar-entity-name">Rezervacije</div>
                                        </>
                                    )}
                                </NavLink>
                            )}

                            {localPlanSubscriptionInfo?.planFeaturesKeys.some(f => f.startsWith("plus-order")) && (
                                <NavLink to={`/live-orders/${localId}/view1`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                    {({ isActive }) => (
                                        <>
                                            <div className="navbar-entity-photo-div">
                                                <img loading="lazy" src={isActive ? OnlineOrderWhiteIcon : OnlineOrderBlackIcon} alt="" className="navbar-entity-photo" />
                                            </div>
                                            <div className="navbar-entity-name">Narudžbine demo</div>
                                        </>
                                    )}
                                </NavLink>
                            )}

                            {localPlanSubscriptionInfo?.planFeaturesKeys.some(f => f.startsWith("plus-order")) && (
                                <NavLink to={`/settings/${localId}/orders-history`} style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                                    {({ isActive }) => (
                                        <>
                                            <div className="navbar-entity-photo-div">
                                                <img loading="lazy" src={isActive ? HistoryWhiteIcon : HistoryBlackIcon} alt="" className="navbar-entity-photo" />
                                            </div>
                                            <div className="navbar-entity-name">Istorija porudžbina</div>
                                        </>
                                    )}
                                </NavLink>
                            )}

                        </div>
                        <div className="navbar-footer-div">

                            <NavLink to="/select-local" style={{ textDecoration: "none", color: "inherit" }} className="navbar-footer-entity-div change-local">
                                <img loading="lazy" src={ChangeUsersIcon} alt="" className="navbar-entity-photo" />
                                <div className="text-block-21">Promeni lokaciju</div>
                            </NavLink>

                            <NavLink to="/logout" style={{ textDecoration: "none", color: "inherit" }} className="navbar-footer-entity-div log-out" onClick={() => { logout(); }}>
                                <img loading="lazy" src={LogoutBlackIcon} alt="" className="navbar-entity-photo" />
                                <div className="text-block-22">Odjavi se</div>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default SettingsNavbar;